import { Route, Routes } from "react-router-dom";
import "./App.scss";
import Home from "./Home";

function App() {
  return (
    <Routes>
      <Route path="/:code" element={<Home />} />
      <Route path="/:code/:testPassword" element={<Home />} />
      <Route path="/" element={<Home />} />

    </Routes>
  );
}

export default App;
  